import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 33"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.375 16.409c0-5.693 4.62-10.313 10.313-10.313C26.38 6.096 31 10.716 31 16.409 31 22.1 26.38 26.72 20.688 26.72c-5.693 0-10.313-4.62-10.313-10.312M20.688 7.97c-4.657 0-8.438 3.78-8.438 8.438 0 4.656 3.78 8.437 8.438 8.437 4.656 0 8.437-3.78 8.437-8.437s-3.78-8.438-8.437-8.438M3.813 10.784c0-.518.42-.938.937-.938H8.5a.937.937 0 1 1 0 1.875H4.75a.937.937 0 0 1-.937-.937M3.813 22.034c0-.518.42-.938.937-.938H8.5a.937.937 0 1 1 0 1.875H4.75a.937.937 0 0 1-.937-.937M1 16.409c0-.518.42-.938.938-.938h4.687a.937.937 0 1 1 0 1.875H1.938A.937.937 0 0 1 1 16.409"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M21.39 15.48h-1.406c-1.172 0-1.172-.572-1.172-.825s0-.825 1.172-.825h3.047a.94.94 0 0 0 .938-.937.94.94 0 0 0-.938-.938h-1.406v-.234a.94.94 0 0 0-.937-.937.94.94 0 0 0-.938.937v.253c-1.716.085-2.812 1.116-2.812 2.681 0 1.566 1.2 2.7 3.046 2.7h1.407c1.172 0 1.172.572 1.172.825s0 .825-1.172.825h-3.047a.94.94 0 0 0-.938.938.94.94 0 0 0 .938.937h1.406v.235a.94.94 0 0 0 .938.937.94.94 0 0 0 .937-.937v-.253c1.716-.085 2.813-1.116 2.813-2.682s-1.2-2.7-3.047-2.7"
    />
  </svg>
);
const SvgIconQuickPayments = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconQuickPayments);
export default Memo;
